import axios from 'axios';

export const clientUsersClientesApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/client-users-clients`,
    headers: {
        'Content-Type': 'application/json'
    }
})